/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_about_what_we_build_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We build one tool at a time and hold each to the same standard: it does a single job well, shows the formula or method it uses, and includes worked examples plus answers to the questions people actually ask.`)
};

const es_about_what_we_build_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Construimos una herramienta a la vez y exigimos a cada una el mismo estándar: que haga bien un único trabajo, que muestre la fórmula o el método que utiliza, e incluya ejemplos resueltos junto con respuestas a las preguntas que la gente realmente hace.`)
};

const de_about_what_we_build_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wir bauen ein Werkzeug nach dem anderen und legen bei jedem denselben Maßstab an: Es erledigt eine einzige Aufgabe gut, zeigt die verwendete Formel oder Methode und enthält durchgerechnete Beispiele sowie Antworten auf die Fragen, die Menschen tatsächlich stellen.`)
};

const nl_about_what_we_build_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We bouwen één tool tegelijk en houden elke tool aan dezelfde standaard: hij doet één taak goed, toont de gebruikte formule of methode en bevat uitgewerkte voorbeelden plus antwoorden op de vragen die mensen daadwerkelijk stellen.`)
};

const fr_about_what_we_build_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nous construisons un outil à la fois et exigeons de chacun le même standard : il accomplit une seule tâche parfaitement, montre la formule ou la méthode qu’il utilise, et inclut des exemples résolus ainsi que des réponses aux questions que les gens posent réellement.`)
};

const it_about_what_we_build_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Costruiamo uno strumento alla volta e applichiamo a ciascuno lo stesso standard: svolge un unico compito in modo eccellente, mostra la formula o il metodo utilizzato e include esempi svolti oltre alle risposte alle domande che le persone si pongono davvero.`)
};

const pt_br2_about_what_we_build_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Construímos uma ferramenta de cada vez e mantemos o mesmo padrão para todas: ela faz um único trabalho muito bem, mostra a fórmula ou o método que usa, e inclui exemplos resolvidos além de respostas às perguntas que as pessoas realmente fazem.`)
};

const pt_about_what_we_build_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Construímos uma ferramenta de cada vez e mantemos o mesmo padrão para todas: cada uma faz um único trabalho muito bem, mostra a fórmula ou o método que utiliza, e inclui exemplos resolvidos e respostas às perguntas que as pessoas realmente fazem.`)
};

const ja_about_what_we_build_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`私たちは一度に1つのツールを構築し、それぞれに同じ基準を課しています。単一の仕事を確実にこなし、使用する数式や方法を示し、実際に人々が尋ねる質問への回答とともに解いた例を含めることです。`)
};

const zh_about_what_we_build_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我们一次专注打造一款工具，并对每一款都坚持同样的标准：把单一任务做好，展示所使用的公式或方法，并附上示例演算以及人们真正会问的问题的答案。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const about_what_we_build_p1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.about_what_we_build_p1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("about_what_we_build_p1", locale)
	if (locale === "en") return en_about_what_we_build_p1(inputs)
	if (locale === "es") return es_about_what_we_build_p1(inputs)
	if (locale === "de") return de_about_what_we_build_p1(inputs)
	if (locale === "nl") return nl_about_what_we_build_p1(inputs)
	if (locale === "fr") return fr_about_what_we_build_p1(inputs)
	if (locale === "it") return it_about_what_we_build_p1(inputs)
	if (locale === "pt-BR") return pt_br2_about_what_we_build_p1(inputs)
	if (locale === "pt") return pt_about_what_we_build_p1(inputs)
	if (locale === "ja") return ja_about_what_we_build_p1(inputs)
	return zh_about_what_we_build_p1(inputs)
};